import styled from 'styled-components';
import { Chip as MuiChip } from '@mui/material';
import Button from '../../../components/Button';
import colors from '../../../styles/colors';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 20px;
`;

const AddLiaisonButton = styled(Button)`
  margin-right: 12px;
`;

const PoolButton = styled(Button)`
  margin-right: 12px;
`;

const UserNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LiaisonChip = styled(MuiChip)`
  && {
    background-color: ${colors.shades.primary3};
    color: #000;
    font-size: 12px;
    height: 24px;
    border-radius: 4px;
    font-weight: 500;
  }
`;

export {
  ButtonContainer,
  AddLiaisonButton,
  PoolButton,
  UserNameContainer,
  LiaisonChip,
};
